/**
 * @fileoverview FSE (B-wait, owner 2026-09-28): the published render paints the first screen's entrance running from
 * first paint. These are the markers the server render adds; element-animations.css keys the <html> gate on
 * SSR_ENTRANCE_CLASS and the keyframes read SSR_FROM_OPACITY_VAR.
 * @module screen-view-v2/animations/ssrEntrance
 */
import type { CSSProperties } from 'react';
import type { ResolvedElementAnimationSpec } from './elementAnimationSpec';

/** Marker on entrance elements the server render emits (the <html> gate in element-animations.css keys on it) */
export const SSR_ENTRANCE_CLASS = 'sv2-anim--ssr';
/** Entrance keyframes start at var(--sv2-anim-from-opacity, 0) */
export const SSR_FROM_OPACITY_VAR = '--sv2-anim-from-opacity';
/** Invisible to the eye, but Chrome counts the first frame for Largest Contentful Paint */
export const SSR_FROM_OPACITY = '0.01';

export function ssrEntranceProps(
  spec: Pick<ResolvedElementAnimationSpec, 'className' | 'vars'>,
): { className: string; style: CSSProperties } {
  return {
    className: `${spec.className} ${SSR_ENTRANCE_CLASS}`,
    style: { ...spec.vars, [SSR_FROM_OPACITY_VAR]: SSR_FROM_OPACITY } as CSSProperties,
  };
}
